import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import CreateUserRouteModal from '../modals/CreateDomainModal';
import FiltersMultiSelect from '../../../../common/filtersMultiSelect/FiltersMultiSelect';
import { IconPlus } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

const ShortlinksTopToolbar = ({
    filterOptions,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
}) => {
    const [
        createDomainOpened,
        { open: openCreateModal, close: closeCreateModal },
    ] = useDisclosure();

    return (
        <Group
            w={'100%'}
            h={'100%'}
            px={'lg'}
            justify={'space-between'}>
            <FiltersMultiSelect options={[{ label: 'test', value: 'test' }]} />
            <Flex
                justify={'center'}
                align={'flex-end'}>
                <Group
                    px={'md'}
                    w={'100%'}
                    h={'100%'}
                    justify='flex-end'
                    align={'center'}
                    grow>
                    <Button
                        size={'compact-xs'}
                        leftSection={
                            <IconPlus
                                style={{ width: '70%', height: '70%' }}
                                stroke={1.5}
                            />
                        }
                        styles={{
                            section: {
                                marginInlineEnd: 0,
                            },
                        }}
                        onClick={openCreateModal}>
                        Create Domain
                    </Button>
                    {ToolbarActions ? <ToolbarActions /> : null}
                </Group>
            </Flex>
            <CreateUserRouteModal
                routeId={0}
                opened={createDomainOpened}
                close={closeCreateModal}
            />
        </Group>
    );
};
export default ShortlinksTopToolbar;
